import React from "react";
import { Form } from "sc/ui/components/Form";
import formWithMessages from "sc/ui/components/hoc/formWithMessages";

export const ERROR_EMPTY_USERNAME = "empty_username";

export default formWithMessages(props => {
  const { user, onSave, disabled } = props;
  return (
    <Form
      formProps={{
        id: `username-form`,
        horizontal: true,
      }}
      onSubmit={onSave}
      {...props.messagesProps}
      fields={{
        username: {
          uiProps: {
            type: "text",
            placeholder: "Username",
            autoFocus: true,
            maxLength: 100,
          },
          position: 2,
          initialValue: user.username,
          label: "Username",
        },
      }}
      validation={formData => {
        if (!formData.username) return ERROR_EMPTY_USERNAME;
        return undefined;
      }}
      submitButtonProps={{
        disabled,
        children: "Save",
        bsStyle: "primary",
      }}
      errorMessages={{
        [ERROR_EMPTY_USERNAME]: "Username can't be empty",
      }}
    />
  );
});



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/components/forms/Username.js